import jQuery from 'jquery';
import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import FilterHelper from './FilterHelper.jsx';
import Configurator from './Configurator.jsx';
import Image from './ui/Image.jsx';
import IekArticleList from './ui/IekArticleList.jsx';
import styles from './StabilizerConfigurator.styl';
import Button from './ui/button/Button.jsx';


const KP = JSON.parse('{"0.1":{"0":"0","1":"8.00","2":"6.22","3":"4.05","4":"3.24","5":"2.84","6":"2.64","7":"2.49","8":"2.37","9":"2.27","10":"2.18","11":"2.11","12":"2.04","13":"1.99","14":"1.94","15":"1.89","16":"1.85","17":"1.81","18":"1.78","19":"1.75","20":"1.72","21":"1.69","22":"1.67","23":"1.64","24":"1.62","25":"1.60","30":"1.51","35":"1.44","40":"1.40","45":"1.35","50":"1.30","60":"1.25","70":"1.20","80":"1.16","90":"1.13","100":"1.10","101":"1.00"},"0.2":{"0":"0","1":"4.00","2":"3.39","3":"2.31","4":"1.91","5":"1.72","6":"1.62","7":"1.54","8":"1.48","9":"1.43","10":"1.39","11":"1.35","12":"1.32","13":"1.29","14":"1.27","15":"1.25","16":"1.23","17":"1.21","18":"1.19","19":"1.17","20":"1.16","21":"1.15","22":"1.13","23":"1.12","24":"1.11","25":"1.10","30":"1.05","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"},"0.3":{"0":"0","1":"2.67","2":"2.45","3":"1.74","4":"1.47","5":"1.35","6":"1.28","7":"1.23","8":"1.19","9":"1.16","10":"1.13","11":"1.10","12":"1.08","13":"1.06","14":"1.05","15":"1.03","16":"1.02","17":"1.00","18":"1.00","19":"1.00","20":"1.00","21":"1.00","22":"1.00","23":"1.00","24":"1.00","25":"1.00","30":"1.00","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"},"0.4":{"0":"0","1":"2.00","2":"1.98","3":"1.45","4":"1.25","5":"1.16","6":"1.11","7":"1.12","8":"1.10","9":"1.09","10":"1.07","11":"1.06","12":"1.05","13":"1.04","14":"1.02","15":"1.00","16":"1.00","17":"1.00","18":"1.00","19":"1.00","20":"1.00","21":"1.00","22":"1.00","23":"1.00","24":"1.00","25":"1.00","30":"1.00","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"},"0.5":{"0":"0","1":"1.60","2":"1.60","3":"1.34","4":"1.21","5":"1.16","6":"1.13","7":"1.10","8":"1.08","9":"1.07","10":"1.05","11":"1.04","12":"1.03","13":"1.01","14":"1.00","15":"1.00","16":"1.00","17":"1.00","18":"1.00","19":"1.00","20":"1.00","21":"1.00","22":"1.00","23":"1.00","24":"1.00","25":"1.00","30":"1.00","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"},"0.6":{"0":"0","1":"1.33","2":"1.33","3":"1.22","4":"1.12","5":"1.08","6":"1.06","7":"1.04","8":"1.02","9":"1.01","10":"1.00","11":"1.00","12":"1.00","13":"1.00","14":"1.00","15":"1.00","16":"1.00","17":"1.00","18":"1.00","19":"1.00","20":"1.00","21":"1.00","22":"1.00","23":"1.00","24":"1.00","25":"1.00","30":"1.00","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"},"0.7":{"0":"0","1":"1.14","2":"1.14","3":"1.14","4":"1.06","5":"1.03","6":"1.01","7":"1.00","8":"1.00","9":"1.00","10":"1.00","11":"1.00","12":"1.00","13":"1.00","14":"1.00","15":"1.00","16":"1.00","17":"1.00","18":"1.00","19":"1.00","20":"1.00","21":"1.00","22":"1.00","23":"1.00","24":"1.00","25":"1.00","30":"1.00","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"},"0.8":{"0":"0","1":"1.00","2":"1.00","3":"1.00","4":"1.00","5":"1.00","6":"1.00","7":"1.00","8":"1.00","9":"1.00","10":"1.00","11":"1.00","12":"1.00","13":"1.00","14":"1.00","15":"1.00","16":"1.00","17":"1.00","18":"1.00","19":"1.00","20":"1.00","21":"1.00","22":"1.00","23":"1.00","24":"1.00","25":"1.00","30":"1.00","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"},"0.9":{"0":"0","1":"1.00","2":"1.00","3":"1.00","4":"1.00","5":"1.00","6":"1.00","7":"1.00","8":"1.00","9":"1.00","10":"1.00","11":"1.00","12":"1.00","13":"1.00","14":"1.00","15":"1.00","16":"1.00","17":"1.00","18":"1.00","19":"1.00","20":"1.00","21":"1.00","22":"1.00","23":"1.00","24":"1.00","25":"1.00","30":"1.00","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"},"1.0":{"0":"0","1":"1.00","2":"1.00","3":"1.00","4":"1.00","5":"1.00","6":"1.00","7":"1.00","8":"1.00","9":"1.00","10":"1.00","11":"1.00","12":"1.00","13":"1.00","14":"1.00","15":"1.00","16":"1.00","17":"1.00","18":"1.00","19":"1.00","20":"1.00","21":"1.00","22":"1.00","23":"1.00","24":"1.00","25":"1.00","30":"1.00","35":"1.00","40":"1.00","45":"1.00","50":"1.00","60":"1.00","70":"1.00","80":"1.00","90":"1.00","100":"1.00","101":"1.00"}}');

/**
 * Конфигуратор стабилизаторов напряжения IEK
 */
class StabilizerConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = {
			db: null,

			filterStabilizer: {}, // Фильтр стабилизатора

			item: null, // Выбранный стабилизатор

			showPopup: false, // Показать всплывающее окно расчета требуемой мощности

			phases: 0, // Количество фаз: 1 или 3

			singlePhaseConsumers: [], // Однофазные потребители
			threePhaseConsumers: [],  // Трехфазные потребители

			// Минимальное напряжение в электросети, к которой подключается стабилизатор, В
			singlePhasePowerSurge: 12, // 1 фаза
			threePhasePowerSurge: 8,   // 3 фазы

			singlePhaseTotalPowerKVA: 0, // Суммарная мощность, кВА
			threePhaseTotalPowerKVA: 0,  // Суммарная мощность, кВА

			requiredPower: 0, // Необходимая мощность нагрузки, Вт
			singlePhaseTotalConsumerPower: 0,
			threePhaseTotalConsumerPower: 0,

			popupManualPower: 0,

			picked: false, // Подобрать стабилизаторы
			pickedFromPopup: false
		};

		this.onChangeFilterStabilizerPower = this.onChangeFilterStabilizerPower.bind(this);
		this.onBtnCalc       = this.onBtnCalc.bind(this);
		this.onBtnPickUp     = this.onBtnPickUp.bind(this);
		this.onConsumerCheck = this.onConsumerCheck.bind(this);
		this.consumerToRow   = this.consumerToRow.bind(this);
		this.onPopupClose    = this.onPopupClose.bind(this);
		this.onPopupPickUp   = this.onPopupPickUp.bind(this);
		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
		this.onBtnCalcSavePdfClick = this.onBtnCalcSavePdfClick.bind(this);
		this.doCalc          = this.doCalc.bind(this);
	}

	getType() {
		return 'stabilizer';
	}

	getCustomStyles() {
		return styles;
	}

	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;

				db.filters.stabilizers.voltage_min.sort((a, b) => {
					return a - b;
				});

				const singlePhaseConsumers = db.consumers
					.filter(consumer => consumer.phase === '1')
					.map(consumer => {consumer.checked = false; consumer.quantity = 1; return consumer; });

				const threePhaseConsumers = db.consumers
					.filter(consumer => consumer.phase === '3')
					.map(consumer => {consumer.checked = false; consumer.quantity = 1; return consumer; });

				this.setState(() => {
					return {
						db,
						singlePhaseConsumers,
						threePhaseConsumers
					};
				});
			}
		);
	}

	doPrint(params) {
		if (!this.state.item && (!('data' in params) || params.data.stabilizerPrintType !== 'calclist')) {
			alert('Выберите стабилизатор для печати');
			return;
		}

		let _params = params || {};

		_params.data = _params.data || {};

		_params.data = jQuery.extend({}, _params.data, {
			printMinVoltage: this.state.phases === 1 ?
				this.state.singlePhasePowerSurge * 10 + 90
				: this.state.threePhasePowerSurge * 10 + 130,

			printPower: this.state.phases === 1 ?
				this.state.singlePhaseTotalConsumerPower
				: this.state.threePhaseTotalConsumerPower,

			consumers: JSON.stringify((this.state.phases === 1 ?
				this.state.singlePhaseConsumers : this.state.threePhaseConsumers)
				.filter(consumer => consumer.checked))
		});

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	onBtnCalcSavePdfClick() {
		this.doPrint({
			format: 'pdf',
			data: {
				stabilizerPrintType: 'calclist'
			}
		});
	}

	getStabilizerList() {

		if (this.state.picked)
		{
			let stabList = this.state.db.stabilizers.filter(stabilizer => {

				if (this.state.phases === 1 && stabilizer.voltage !== 'Однофазная') {
					return false;
				} else if (this.state.phases === 3 && stabilizer.voltage !== 'Трехфазная') {
					return false;
				}

				let sps = 0;

				if (this.state.phases === 1)
				{
					for (let i = this.state.singlePhasePowerSurge; i >= 0; i--)
					{
						sps = this.state.singlePhaseTotalPowerKVA * this.state.db.ku[stabilizer.series][i * 10 + 90];

						if (sps > 1) {
							break;
						}
					}
				}
				else if (this.state.phases === 3)
				{
					for (let i = this.state.threePhasePowerSurge; i >= 0; i--)
					{
						sps = this.state.threePhaseTotalPowerKVA * this.state.db.ku[stabilizer.series][i * 10 + 130];

						if (sps > 1) {
							break;
						}
					}
				}

				if (sps < 1) {
					return false;
				}

				// console.log({series: stabilizer.series, sps: sps});

				return parseInt(stabilizer.power) > sps;
			});

			return stabList.filter(stabilizer => {
				for (const filterPropName in this.state.filterStabilizer)
				{
					if (this.state.filterStabilizer[filterPropName] !== stabilizer[filterPropName]) {
						return false;
					}
				}
				return true;
			});
		}


		if (jQuery.isEmptyObject(this.state.filterStabilizer)) {
			return this.state.db.stabilizers.slice();
		}

		return this.state.db.stabilizers.filter(stabilizer => {
			for (const filterPropName in this.state.filterStabilizer)
			{
				if (this.state.filterStabilizer[filterPropName] !== stabilizer[filterPropName]) {
					return false;
				}
			}
			return true;
		});
	}

	onChangeStabilizerFilter(prop, value) {
		if (value === '' && this.state.requiredPower)
		{
			if (confirm('Внимание! Фильтр по мощности также будет сброшен!'))
			{
				let filterStabilizer = jQuery.extend({}, this.state.filterStabilizer);

				delete filterStabilizer[prop];

				let st = {
					filterStabilizer,
					requiredPower: 0,
					popupManualPower: 0,
					singlePhaseTotalConsumerPower: 0,
					threePhaseTotalConsumerPower: 0,
					singlePhaseTotalPowerKVA: 0,
					threePhaseTotalPowerKVA: 0,
					picked: false,
					phases: 0
				};

				st.singlePhaseConsumers = this.state.singlePhaseConsumers.map(consumer => {
					let _consumer = jQuery.extend({}, consumer);
					_consumer.checked = false;
					return _consumer;
				});

				st.threePhaseConsumers = this.state.threePhaseConsumers.map(consumer => {
					let _consumer = jQuery.extend({}, consumer);
					_consumer.checked = false;
					return _consumer;
				});

				this.doCalc(0, true, st);

				return;
			}
		}

		this.setState(prevState => {
			let filterStabilizer = jQuery.extend({}, prevState.filterStabilizer);

			if (value === '')
			{
				delete filterStabilizer[prop];
			}
			else
			{
				filterStabilizer[prop] = value;
			}

			let phases = prevState.phases;
			if (prop === 'voltage') {
				phases = value === '' ? 0 : value === 'Однофазная' ? 1 : 3;
			}

			return {
				filterStabilizer,
				phases
			};
		});
	}

	onChangeFilterStabilizerPower(event) {
		let filterStabilizerPower = parseInt(event.target.value);

		if (event.target.value === '' || isNaN(filterStabilizerPower) || filterStabilizerPower < 0) {
			filterStabilizerPower = 0;
		}

		let st = {};

		st.requiredPower = filterStabilizerPower;

		if (this.state.pickedFromPopup) {
			st.pickedFromPopup = false;
		}

		if (this.state.phases === 1)
		{
			st.singlePhaseConsumers = this.state.singlePhaseConsumers.map(consumer => {
				let _consumer = jQuery.extend({}, consumer);
				_consumer.checked = false;
				return _consumer;
			});

			st.singlePhaseTotalConsumerPower = 0;
		}
		else
		{
			st.threePhaseConsumers = this.state.threePhaseConsumers.map(consumer => {
				let _consumer = jQuery.extend({}, consumer);
				_consumer.checked = false;
				return _consumer;
			});

			st.threePhaseTotalConsumerPower = 0;
		}

		this.setState(st);
	}

	onBtnPickUp() {
		if (!('voltage' in this.state.filterStabilizer)) {
			alert('Для подбора стабилизатора выберите тип сети');
			return;
		}

		this.doCalc(this.state.requiredPower, true, {pickedFromPopup: false});
	}

	onBtnCalc() {
		if (!('voltage' in this.state.filterStabilizer)) {
			alert('Для расчета выберите тип сети');
			return;
		}

		this.setState({
			showPopup: true,
			requiredPower: 0,
			singlePhaseTotalConsumerPower: 0,
			singlePhaseTotalPowerKVA: 0,
			threePhaseTotalConsumerPower: 0,
			threePhaseTotalPowerKVA: 0,
			picked: false
		});
	}

	onPopupClose() {
		this.setState({
			showPopup: false
		});
	}

	decimalAdjust(type, value, exp) {
		// Если степень не определена, либо равна нулю...
		if (typeof exp === 'undefined' || +exp === 0) {
			return Math[type](value);
		}
		value = +value;
		exp = +exp;
		// Если значение не является числом, либо степень не является целым числом...
		if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
			return NaN;
		}
		// Сдвиг разрядов
		value = value.toString().split('e');
		value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
		// Обратный сдвиг
		value = value.toString().split('e');
		return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
	}

	/**
	 * Выбрать стабилизатора в всплывающем окне
	 */
	onPopupPickUp() {
		this.doCalc(
			this.state.popupManualPower,
			false,
			{
				picked: true,
				pickedFromPopup: true,
				showPopup: false
			}
		);
	}

	calcKpN(n) {
		let kpn = n;

		if (kpn > 100) {
			kpn = 101;
		} else if (kpn > 25 && kpn < 30) {
			kpn = 25;
		} else if (kpn > 30 && kpn < 35) {
			kpn = 30;
		} else if (kpn > 35 && kpn < 40) {
			kpn = 35;
		} else if (kpn > 40 && kpn < 45) {
			kpn = 40;
		} else if (kpn > 45 && kpn < 50) {
			kpn = 45;
		} else if (kpn > 50 && kpn < 60) {
			kpn = 50;
		} else if (kpn > 60 && kpn < 70) {
			kpn = 60;
		} else if (kpn > 70 && kpn < 80) {
			kpn = 70;
		} else if (kpn > 80 && kpn < 90) {
			kpn = 80;
		} else if (kpn > 90 && kpn < 100) {
			kpn = 50;
		}

		return kpn;
	}

	/**
	 * Выполнить расчет
	 *
	 * @param totalPower Доп. мощность не учтенная в таблице
	 * @param isManual Ручной расчет, только по мощности, без учета потребителей
	 * @param addState
	 */
	doCalc(totalPower, isManual, addState) {

		if (isManual && !totalPower)
		{
			let st = {
				picked: false
			};

			if (addState) {
				jQuery.extend(st, addState);
			}

			this.setState(st);

			return;
		}

		const checkedConsumers = isManual ? [] : (this.state.phases === 1 ?
			this.state.singlePhaseConsumers.filter(consumer => {return consumer.checked}) :
			this.state.threePhaseConsumers.filter(consumer => {return consumer.checked}));

		if (totalPower)
		{
			checkedConsumers.push({
				quantity: 1,
				ki: 0.4,
				cosf: 0.8,
				tgf: 0.75,
				power: totalPower
			});
		}

		if (checkedConsumers.length === 0)
		{
			let st = {
				requiredPower: totalPower
			};

			if (addState) {
				jQuery.extend(st, addState);
			}

			if (this.state.phases === 1) {
				st.singlePhaseTotalPowerKVA = 0;
				st.singlePhaseTotalConsumerPower = 0;
			} else {
				st.threePhaseTotalPowerKVA = 0;
				st.threePhaseTotalConsumerPower = 0;
			}

			this.setState(st);

			return;
		}

		let pps0 = 0;
		let qps0 = 0;
		let sps0 = 0;

		let npns   = 0;
		let npn2s  = 0;
		let kinpns = 0;
		let maxnpn = 0;

		let totalConsumerPower = 0;

		checkedConsumers.forEach(consumer => {

			totalConsumerPower += consumer.quantity * consumer.power;

			consumer._ki   = parseFloat(consumer.ki);
			consumer.npn   = consumer.quantity * consumer.power;
			consumer.npn2  = consumer.quantity * Math.pow(consumer.power, 2);
			consumer.kinpn = consumer._ki * consumer.npn;
			consumer.kp    = consumer.quantity === 0 ? 0 : parseFloat(KP[this.decimalAdjust('floor', consumer._ki, -1).toFixed(1)][this.calcKpN(consumer.quantity)]);
			consumer.pp    = consumer.kinpn * consumer.kp;
			consumer.qp    = parseFloat((1.1 * consumer.tgf * consumer.pp).toFixed(2));
			consumer.sp    = parseFloat((Math.sqrt(Math.pow(consumer.pp, 2) + Math.pow(consumer.qp, 2))).toFixed(2));

			pps0 += consumer.pp;
			qps0 += consumer.qp;
			sps0 += consumer.sp;

			npns   += consumer.npn;
			npn2s   = +consumer.power > npn2s ? +consumer.power : npn2s;
			kinpns += consumer.kinpn;

			maxnpn = Math.max(consumer.npn, maxnpn);
		});

		pps0 = parseFloat(pps0.toFixed(2));
		qps0 = parseFloat(qps0.toFixed(2));
		sps0 = parseFloat(sps0.toFixed(2));

		const ne   = Math.floor(2 * npns / npn2s);
		const kis  = this.decimalAdjust('floor', kinpns / npns, -1).toFixed(1);
		const tfs  = this.decimalAdjust('round', qps0 / (1.1 * pps0), -2);
		const kps  = ne === 0 ? 0 : parseFloat(KP[kis][this.calcKpN(ne)]);
		const pps1 = kis * npns * kps;
		const qps1 = parseFloat((1.1 * tfs * pps1).toFixed(2));
		const sps1 = Math.round(1.3 * Math.sqrt(Math.pow(pps1, 2) + Math.pow(qps1, 2)));

		// console.log(checkedConsumers);
		// console.log({
		// 	'pps0': pps0, 'qps0': qps0, 'sps0': sps0, 'maxnpn': maxnpn, 'ne': ne, 'kis': kis, 'tfs': tfs,
		// 	'npns': npns, 'npn2s': npn2s, 'kinpns': kinpns, 'kps': kps, 'pps1': pps1, 'qps1': qps1, 'sps1': sps1
		// });

		let st = {};

		if (addState) {
			jQuery.extend(st, addState);
		}

		if (isManual)
		{
			st['picked'] = true;
			st['singlePhaseConsumers'] = this.state.singlePhaseConsumers.map(consumer => {
				let _consumer = jQuery.extend({}, consumer);
				_consumer.checked = false;
				return _consumer;
			});
			st['threePhaseConsumers'] = this.state.threePhaseConsumers.map(consumer => {
				let _consumer = jQuery.extend({}, consumer);
				_consumer.checked = false;
				return _consumer;
			});
		}
		else
		{
			st['requiredPower'] = totalConsumerPower;
		}

		if (this.state.phases === 1)
		{
			st['singlePhaseTotalPowerKVA'] = sps1;
			st['singlePhaseTotalConsumerPower'] = isManual ? totalPower : totalConsumerPower;
		}
		else
		{
			st['threePhaseTotalPowerKVA'] = sps1;
			st['threePhaseTotalConsumerPower'] = isManual ? totalPower : totalConsumerPower;
		}

		this.setState(st);
	}

	/**
	 * Выбор потребителя
	 */
	onConsumerCheck(event, consumer) {
		consumer.checked = event.target.checked;
		this.doCalc(this.state.popupManualPower);
	}

	consumerToRow(consumer) {
		const consumerDisabled = parseInt(consumer.power) === 0;

		let validateNumeric = value => {
			let v = parseInt(value);

			if (isNaN(v) || v < 1) {
				return 1;
			}

			return v;
		};

		return (
			<div>
				<div style={{width: '227px', padding: '8px 16px', fontSize: '9px'}}>
					<label style={{display: 'block', cursor: 'pointer', color: consumerDisabled ? '#f00' : '#2b4244'}}>
						<input type="checkbox" style={{verticalAlign: 'middle'}} checked={consumer.checked} disabled={consumerDisabled}
									 onChange={event => this.onConsumerCheck(event, consumer)} />
						<span style={{display: 'inline-block', width: '170px', verticalAlign: 'middle', paddingLeft: '8px'}}>{consumer.name}</span>
					</label>
				</div>
				<div style={{width: '65px', padding: '0 16px 0 0'}}>
					{!consumerDisabled && <input type="text" className={styles.popupTableNum} value={consumer.quantity}
						onChange={event => {consumer.quantity = validateNumeric(event.target.value); this.doCalc(this.state.popupManualPower);}} />}
				</div>
				<div style={{width: '72px'}}>
					{!consumerDisabled && <input type="text" className={styles.popupTableNum} value={consumer.power}
						onChange={event => {consumer.power = validateNumeric(event.target.value); this.doCalc(this.state.popupManualPower);}} />}
				</div>
			</div>
		);
	}


	render() {
		if (!this.state.db) {
			return <div className={styles.cfg}><div className={styles.title}>Конфигуратор стабилизаторов напряжения IEK</div></div>;
		}

		const stabilizerList = this.getStabilizerList();
		stabilizerList.sort((a, b) => {
			const _a = parseInt(a.power);
			const _b = parseInt(b.power);

			if (_a > _b) {
				return 1;
			}
			if (_a < _b) {
				return -1;
			}
			return 0;
		});

		const filterStabSeries = FilterHelper.getFilter(stabilizerList, this.state.db.filters.stabilizers.series, 'series', this.state.filterStabilizer, this.getStabilizerList, this).map(item => {
			return (<option key={item} value={item}>{item}</option>);
		});
		if (filterStabSeries.length === 0 && this.state.filterStabilizer.series) {
			const vItem = this.state.filterStabilizer.series;
			filterStabSeries.push(<option key={'v_' + vItem} value={vItem}>{vItem}</option>);
		}

		const filterStabType = FilterHelper.getFilter(stabilizerList, this.state.db.filters.stabilizers.type, 'type', this.state.filterStabilizer, this.getStabilizerList, this).map(item => {
			return (<option key={item} value={item}>{item}</option>);
		});
		if (filterStabType.length === 0 && this.state.filterStabilizer.type) {
			const vItem = this.state.filterStabilizer.type;
			filterStabType.push(<option key={'v_' + vItem} value={vItem}>{vItem}</option>);
		}

		let filterStabVoltage = FilterHelper.getFilter(stabilizerList, this.state.db.filters.stabilizers.voltage, 'voltage', this.state.filterStabilizer, this.getStabilizerList, this).map(item => {
			return (<option key={item} value={item}>{item}</option>);
		});
		if (filterStabVoltage.length === 0 && this.state.phases) {
			const vItem = this.state.phases === 1 ? this.state.db.filters.stabilizers.voltage[0] : this.state.db.filters.stabilizers.voltage[1];
			filterStabVoltage.push(<option key={'v_' + vItem} value={vItem}>{vItem}</option>);
		}

		const filterStabVoltageMin = FilterHelper.getFilter(stabilizerList, this.state.db.filters.stabilizers.voltage_min, 'voltage_min', this.state.filterStabilizer, this.getStabilizerList, this).map(item => {
			return (<option key={item} value={item}>{item}</option>);
		});
		if (filterStabVoltageMin.length === 0 && this.state.filterStabilizer.voltage_min) {
			const vItem = this.state.filterStabilizer.voltage_min;
			filterStabVoltageMin.push(<option key={'v_' + vItem} value={vItem}>{vItem}</option>);
		}
		filterStabVoltageMin.sort();


		// Потребители
		const consumerList = this.state.phases === 1 ? this.state.singlePhaseConsumers : this.state.threePhaseConsumers;

		let consumerRows = [];

		for (let i = 0; i < consumerList.length; i += 2)
		{
			consumerRows.push(
				<div key={i} style={{display: 'block', backgroundColor: (i % 4 === 0 ? '#fff' : '#e5e7e8')}}>
					{this.consumerToRow(consumerList[i])}
					<div style={{width: '40px'}}>&nbsp;</div>
					{consumerList[i + 1] && this.consumerToRow(consumerList[i + 1])}
				</div>
			);
		}
		//


		return (
			<div className={styles.cfg}>
				<div className={styles.title}>Конфигуратор стабилизаторов напряжения IEK</div>

				{/* Тип стабилизатора */}
				<select className={styles.stabFilterType} value={'type' in this.state.filterStabilizer ? this.state.filterStabilizer.type : ''} onChange={event => this.onChangeStabilizerFilter('type', event.target.value)}>
					<option value="">Все</option>
					{filterStabType}
				</select>

				{/* Серия */}
				<select className={styles.stabFilterSeries} value={'series' in this.state.filterStabilizer ? this.state.filterStabilizer.series : ''} onChange={event => this.onChangeStabilizerFilter('series', event.target.value)}>
					<option value="">Все</option>
					{filterStabSeries}
				</select>

				{/* Тип сети */}
				<select className={styles.stabFilterVoltage} value={'voltage' in this.state.filterStabilizer ? this.state.filterStabilizer.voltage : ''} onChange={event => this.onChangeStabilizerFilter('voltage', event.target.value)}>
					<option value="">Все</option>
					{filterStabVoltage}
				</select>

				{/* Min. входное напряжение, В */}
				<select className={styles.stabFilterVoltageMin} value={'voltage_min' in this.state.filterStabilizer ? this.state.filterStabilizer.voltage_min : ''} onChange={event => this.onChangeStabilizerFilter('voltage_min', event.target.value)}>
					<option value="">Все</option>
					{filterStabVoltageMin}
				</select>

				{/* Изменение напряжения в сети */}
				{this.state.phases > 0 &&
					<span className={styles.mainSliderLabel}>Минимальное напряжение в электросети, к которой подключается стабилизатор, В:</span>
				}
				{this.state.phases === 0 ? null : this.state.phases === 1 ?
					<Slider key="single" className={styles.mainSliderOnePhase} itemClassName={styles.mainSliderItem} value={this.state.singlePhasePowerSurge} w={480} n={13} m={28}
									onUpdate={value => {this.setState({singlePhasePowerSurge: value})}} />
					:
					<Slider key="three" className={styles.mainSliderThreePhase} itemClassName={styles.mainSliderItem} value={this.state.threePhasePowerSurge} w={330} n={9} m={17}
									onUpdate={value => {this.setState({threePhasePowerSurge: value})}} />
				}

				<span className={styles.powerSumLabel}>Суммарная мощность нагрузки, Вт:</span>

				<span className={styles.powerSumLabelHelp}>Не знаете, как рассчитать<br/>суммарную мощность нагрузки?</span>

				{/* Требуемая мощность нагрузки, Вт */}
				<input
					className={styles.stabFilterPower}
					type="text"
					value={this.state.requiredPower === 0 ? '' : this.state.requiredPower}
					onChange={this.onChangeFilterStabilizerPower}
				/>

				<span className={styles.totalPowerKVA}>{this.state.phases === 1 ?
					(this.state.singlePhaseTotalPowerKVA / 1000).toFixed(1) :
					(this.state.threePhaseTotalPowerKVA / 1000).toFixed(1)} кВА

					<Tooltip placement="right" overlay={<div style={{width: '210px'}}>Значение полной расчётной мощности электроприемников (в ВА) с учетом длительности и одновременности работы приборов</div>}>
						<span className={styles.totalPowerKVAHelp}>?</span>
					</Tooltip>
				</span>

				{/* Подобрать */}
				<div className={styles.btnPickUp} onClick={this.onBtnPickUp}>
					{this.state.pickedFromPopup &&
						<div className={styles.btnPickUpDisabledWrap} onClick={e => e.stopPropagation()} title="Заполните мощность в поле для активации ручного подбора" />
					}
				</div>

				{/* Рассчитать */}
				<div className={styles.btnCalc} onClick={this.onBtnCalc} />

				<div className={styles.btnCalcSavePdf} onClick={this.onBtnCalcSavePdfClick}>Сохранить расчёт в PDF</div>

				<span className={styles.listHelp}>При выборе стабилизатора необходимо учитывать рассчитанные значения суммарной и полной мощностей, либо режимы работы потребителей, характерные для Вашей сети</span>

				{/* Список стабилизаторов */}
				<IekArticleList
					items={stabilizerList}
					wrapStyle={styles.articleList_wrapStyle}
					tableWrapStyle={styles.articleList_tableWrap}
					selectedItem={this.state.item}
					onSelect={item => this.setState({item})}
				/>

				{/* Артикул и имя */}
				{this.state.item ? (
					<div className={styles.itemInfo}>
						<a href={`/products/catalog/?page=detail&article=${this.state.item.article}`} target="_blank"
							 rel="noopener noreferrer" className={styles.itemInfo_Article}>{this.state.item.article}</a>
						<div>{this.state.item.name}</div>
					</div>
				) : (
					<div className={styles.itemInfoNoArticle} />
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg}
					url={this.state.item && this.state.item.photo ? `itkcfg.php?type=${this.getType()}&action=getPhoto&article=${this.state.item.article}` : null}
				/>
				{this.state.item && (
					<Button
						x="615"
						y="463"
						buttonStyle={styles.mainBtn}
						buttonDisabledStyle={styles.mainBtnDisabled}
						textStyle={styles.mainBtnText}
						iconStyle={styles.pickUpBtnIcon}
						text="В корзину"
						disabled={!this.state.item}
						onClick={this.onBtnCartClick}
					/>
				)}
				{/* Описание */}
				{this.state.item && this.state.item.description ? (
					<div className={styles.description}>

						{this.state.item.description}
					</div>
				) : (
					<div className={styles.descriptionEmpty} />
				)}

				{/* Сохранить в PDF */}
				<div className={styles.btnPdf} onClick={this.onBtnPrintPdfClick} />

				{/* Сохранить в Excel */}
				<div className={styles.btnExcel} onClick={this.onBtnExcelClick} />

				{/* Распечатать */}
				<div className={styles.btnPrint} onClick={this.onBtnPrintClick} />

				{/* Где купить? */}
				<a href={this.db.localization.whereToBuyLink[this.props.locale]} target="_blank" className={styles.whereToBuyLink} />

				{/* На основной сайт IEK */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '24px', top: '794px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '24px',
					top: '794px',
					left: '565px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '800px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
				{/* Всплывающее окно расчета мощности */}
				{this.state.showPopup &&
					<div className={styles.popupWrap}>
						<div className={this.state.phases === 1 ? styles.popupOnePhase : styles.popupThreePhase}>
							<div className={styles.popupClose} onClick={this.onPopupClose} />

							{/* Потребители */}
							<div className={styles.popupTableWrap}>
								<div className={styles.popupTable}>{consumerRows}</div>
							</div>

							{/* Ввести суммарную мощность оборудования, не учтенного в таблице, Вт */}
							<input type="text" className={styles.popupChangeTotalPowerInput} value={this.state.popupManualPower}
								onChange={event => this.doCalc(parseInt(event.target.value) ? parseInt(event.target.value) : 0, false, {popupManualPower: parseInt(event.target.value) ? parseInt(event.target.value) : 0})} />

							{/* Изменение напряжения в сети */}
							{this.state.phases === 1 ? (
								<Slider key="single" className={styles.popupSliderOnePhase} itemClassName={styles.popupSliderItem} value={this.state.singlePhasePowerSurge} w={480} n={13} m={28}
									onUpdate={value => {this.setState({singlePhasePowerSurge: value})}} />
							) : (
								<Slider key="three" className={styles.popupSliderThreePhase} itemClassName={styles.popupSliderItem} value={this.state.threePhasePowerSurge} w={330} n={9} m={17}
									onUpdate={value => {this.setState({threePhasePowerSurge: value})}} />
							)}

							{/* Суммарная мощность, Вт */}
							<input type="text" className={styles.popupTotalPowerInput} readOnly={true}
								value={this.state.phases === 1 ? this.state.singlePhaseTotalConsumerPower : this.state.threePhaseTotalConsumerPower} />

							<span className={styles.popupTotalPowerKVA}>{this.state.phases === 1 ?
								(this.state.singlePhaseTotalPowerKVA / 1000).toFixed(1) :
								(this.state.threePhaseTotalPowerKVA / 1000).toFixed(1)} кВА

								<Tooltip placement="left" overlay={<div style={{width: '210px'}}>Значение полной расчётной мощности электроприемников (в ВА) с учетом длительности и одновременности работы приборов</div>}>
									<span className={styles.totalPowerKVAHelp}>?</span>
								</Tooltip>
							</span>

							{/* Выбрать стабилизатор IEK */}
							<div className={styles.popupPickStab} onClick={this.onPopupPickUp} />
						</div>
					</div>
				}

			</div>
		);
	}
}

class Slider extends React.Component
{
	constructor(props) {
		super(props);

		this.state = {
			dragging: false,
			downX: 0
		};

		this.onItemMouseDown     = this.onItemMouseDown.bind(this);
		this.onDocumentMouseUp   = this.onDocumentMouseUp.bind(this);
		this.onDocumentMouseMove = this.onDocumentMouseMove.bind(this);
	}

	componentDidMount() {
		jQuery(document)
			.on('mouseup touchend', this.onDocumentMouseUp)
			.on('mousemove touchmove', this.onDocumentMouseMove);
	}

	onDocumentMouseUp() {
		this.setState({
			dragging: false
		});
	}

	onDocumentMouseMove(event) {
		if (!this.state.dragging) {
			return;
		}

		let pageX = (event.type && event.type === 'touchmove') ? event.originalEvent.touches[0].pageX : event.pageX;

		let value = Math.round((pageX - this.state.downX + this.props.m) / (this.props.w / this.props.n));

		if (value < 0) {
			value = 0;
		} else if (value > this.props.n - 1) {
			value = this.props.n - 1;
		}

		this.props.onUpdate(value);
	}

	componentWillUnmount() {
		jQuery(document)
			.off('mouseup touchend', null, this.onDocumentMouseUp)
			.off('mousemove touchmove', null, this.onDocumentMouseMove);
	}

	onItemMouseDown(event) {
		let pageX = (event.type && event.type === 'touchstart') ? event.touches[0].pageX : event.pageX;

		this.setState({
			dragging: true,
			downX: pageX - this.props.value * (this.props.w / this.props.n) + this.props.m
		});
	}

	render() {
		let cl = { left: this.props.value * (this.props.w / this.props.n) + this.props.m };

		return (
			<div className={this.props.className}>
				<div className={this.props.itemClassName} onMouseDown={this.onItemMouseDown} onTouchStart={this.onItemMouseDown}
					onDragStart={() => {return false;}} style={cl} />
			</div>
		);
	}
}

export default StabilizerConfigurator;



// WEBPACK FOOTER //
// ./src/react/StabilizerConfigurator.jsx